// 新挂号提醒提示音：Web Audio 合成两声短音，无需音频资源文件
// 复用同一个 AudioContext：Chrome 每页约 6 个上限，若每次播放都 new 而不 close，一天内提醒会永久静默
let audioCtx: AudioContext | null = null;

export function playNotifySound() {
  try {
    const Ctx = window.AudioContext || (window as any).webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) {
      audioCtx = new Ctx();
    }
    const ctx = audioCtx;
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }
    const tone = (freq: number, startAt: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.value = freq;
      const t = ctx.currentTime + startAt;
      gain.gain.setValueAtTime(0.25, t);
      gain.gain.exponentialRampToValueAtTime(0.01, t + 0.35);
      osc.start(t);
      osc.stop(t + 0.35);
    };
    tone(880, 0);
    tone(1174.66, 0.4);
  } catch {
    // 浏览器不支持或音频被限制时静默忽略
  }
}
